var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cartao-cabecalho",
      class: {
        "cartao-cabecalho--sem-padding-lateral": _vm.semPaddingLateral,
        "cartao-cabecalho--titulo-grande": _vm.ehSecao,
        "cartao-cabecalho--colapsavel": _vm.clicavel,
        "cartao-cabecalho--recolhido": _vm.clicavel && !_vm.aberto,
        "cartao-cabecalho--escala-etapa": _vm.escala === "etapa"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "ia-block-card__cabecalho",
          class: {
            "ia-block-card__cabecalho--clicavel": _vm.clicavel,
            "ia-block-card__cabecalho--fita": _vm.fita
          },
          attrs: {
            role: _vm.clicavel ? "button" : null,
            tabindex: _vm.clicavel ? "0" : null,
            "aria-expanded": _vm.clicavel ? String(_vm.aberto) : null,
            "aria-labelledby":
              _vm.clicavel && _vm.ehSecao ? _vm.idDoTitulo : null,
            "aria-describedby": _vm.descritoPor,
            "data-teste": _vm.testeGatilho
          },
          on: {
            click: _vm.clicar,
            keydown: [
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.clicar($event)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.clicar($event)
              }
            ]
          }
        },
        [
          _vm.icone
            ? _c("icon-svg", {
                staticClass: "ia-block-card__icone",
                attrs: { name: _vm.icone, size: 14, color: _vm.corDoIcone }
              })
            : _vm._e(),
          _vm.ehSecao
            ? _c("span", { staticClass: "cartao-cabecalho__titulos" }, [
                _vm.sobretitulo
                  ? _c(
                      "span",
                      {
                        staticClass: "cartao-cabecalho__sobretitulo",
                        attrs: { "aria-hidden": _vm.metricasEscondidas }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "az-ds-label",
                            attrs: { "data-teste": _vm.testeSobretitulo }
                          },
                          [_vm._v(_vm._s(_vm.sobretitulo))]
                        )
                      ]
                    )
                  : _vm._e(),
                _c(
                  "span",
                  {
                    staticClass:
                      "ia-block-card__nome cartao-cabecalho__titulo ia-titulo-de-cartao",
                    attrs: {
                      id: _vm.idDoTitulo,
                      "data-teste": _vm.testeTitulo || null
                    }
                  },
                  [_vm._v(_vm._s(_vm.titulo))]
                ),
                _vm.resumo
                  ? _c(
                      "span",
                      {
                        staticClass: "cartao-cabecalho__resumo",
                        attrs: {
                          "aria-hidden": String(!(_vm.clicavel && !_vm.aberto)),
                          "data-teste": "cartao-resumo"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "ia-texto-auxiliar cartao-cabecalho__resumo-texto text-truncate d-block"
                          },
                          [_vm._v(_vm._s(_vm.resumo))]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.temMetricas
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "ia-block-card__subtitulo cartao-cabecalho__metricas",
                        attrs: {
                          id: _vm.idDasMetricas,
                          "aria-hidden": _vm.metricasEscondidas
                        }
                      },
                      [_vm._t("subtitulo")],
                      2
                    )
                  : _vm._e()
              ])
            : _vm.titulo && _vm.fita
            ? _c(
                "span",
                {
                  staticClass: "ia-block-card__titulo",
                  attrs: { "data-teste": _vm.testeTitulo || null }
                },
                [_vm._v(_vm._s(_vm.titulo))]
              )
            : _vm.titulo
            ? _c(
                "span",
                {
                  staticClass:
                    "ia-block-card__nome ia-block-card__nome--compacto",
                  attrs: { "data-teste": _vm.testeTitulo || null }
                },
                [_vm._v(_vm._s(_vm.titulo))]
              )
            : _vm._t("titulo"),
          _vm._t("meta"),
          _vm.$slots.cornerAction
            ? _c(
                "span",
                { staticClass: "cartao-cabecalho__acao" },
                [_vm._t("cornerAction")],
                2
              )
            : _vm._e()
        ],
        2
      ),
      _vm.temMetricas && !_vm.ehSecao
        ? _c(
            "p",
            { staticClass: "ia-block-card__subtitulo mb-0" },
            [_vm._t("subtitulo")],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }